"use client"

import { Menu, MenuButton, MenuList, MenuItem, Button, Text, Icon } from "@chakra-ui/react"
import { ChevronDownIcon, CheckIcon } from "@chakra-ui/icons"
import { FaRegBuilding } from "react-icons/fa"
import { useSupplierRetailer } from "../wrappers/SupplierRetailerContext"
import { neutral, brand, type, radius } from "../theme/tokens"

/**
 * Organisation scope switcher — master admins only.
 *
 * Sits in the command bar next to the profile/sign-out icons and scopes the
 * whole app (supplier dropdown, admin lists) to one organisation. Hidden for
 * everyone else, and hidden pre-migration (no organisations rows = no toggle),
 * so it degrades to nothing on a DB without phase 0.
 */
const OrgToggle = () => {
  const { organisations, selectedOrg, setSelectedOrg, isMaster } = useSupplierRetailer()

  if (!isMaster || organisations.length < 2) return null

  const current = organisations.find((o) => o.org_code === selectedOrg)

  return (
    <Menu placement="bottom-end" autoSelect={false}>
      <MenuButton
        as={Button}
        variant="ghost"
        size="sm"
        leftIcon={<Icon as={FaRegBuilding} fontSize="13px" />}
        rightIcon={<ChevronDownIcon boxSize="14px" opacity={0.7} />}
        fontSize={type.size.small}
        fontWeight={type.weight.semibold}
        color={neutral[700]}
        borderRadius={radius.sm}
        aria-label="Change organisation"
      >
        {current?.org_name || selectedOrg}
      </MenuButton>
      <MenuList minW="220px" py={1} borderColor={neutral[200]} zIndex={1600}>
        {organisations.map((org) => {
          const isActive = org.org_code === selectedOrg
          return (
            <MenuItem
              key={org.org_code}
              onClick={() => setSelectedOrg(org.org_code)}
              fontSize={type.size.small}
              fontWeight={isActive ? type.weight.semibold : type.weight.regular}
              color={isActive ? brand[600] : neutral[700]}
              bg={isActive ? brand[50] : "transparent"}
            >
              <Text flex="1" noOfLines={1}>
                {org.org_name}
              </Text>
              {isActive && <Icon as={CheckIcon} boxSize="11px" ml={2} />}
            </MenuItem>
          )
        })}
      </MenuList>
    </Menu>
  )
}

export default OrgToggle
